import { render, staticRenderFns } from "./Advert.vue?vue&type=template&id=2393f581"
import script from "./Advert.vue?vue&type=script&lang=js"
export * from "./Advert.vue?vue&type=script&lang=js"
import style0 from "./Advert.vue?vue&type=style&index=0&id=2393f581&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports